import { render, staticRenderFns } from "./scalapay-confirm.vue?vue&type=template&id=c5ce39ec&"
import script from "./scalapay-confirm.vue?vue&type=script&lang=js&"
export * from "./scalapay-confirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports